import { Link } from "react-router-dom";
import { images } from "../../Constants/imageslinks.js";

function Footer() {
  return (
    <div className="bg-secondary100">
      <div className="3xl:container 3xl:mx-auto">
        <div className="md:py-[45px] py-5 lg:px-[3.88vw] 3xl:px-[75px] md:px-8 px-4 flex md:flex-row flex-col gap-4 justify-between">
          <img
            src={images.minimis_logo_footer}
            alt="minimis logo"
            className="max-w-[128px]"
          />
          <div className="flex md:flex-row flex-col md:gap-6 gap-2">
            <Link
              to="/terms-of-service"
              className="roboto font-normal text-sm leading-[150%] text-primary100"
            >
              Terms and Conditions
            </Link>
            <Link
              to="/launcher-privacy-policy"
              className="roboto font-normal text-sm leading-[150%] text-primary100"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
